import type { MultiselectSearchOption } from '@shared/ui/fields'

import { useListsStore } from '@shared/model'

interface FilterPaidLabelOptions {
  initial: string[]
}

interface FilterPaidLabelReturn {
  options: ComputedRef<MultiselectSearchOption[]>
  query: Ref<string[]>
  initialValue: ComputedRef<string[]>
  handleSelected: (selected: MultiselectSearchOption[]) => void
}

export const useFilterPaidLabel = ({ initial }: FilterPaidLabelOptions): FilterPaidLabelReturn => {
  const listsStore = useListsStore()

  const query = ref<string[]>(initial)

  const options = computed<MultiselectSearchOption[]>(() => {
    const paidLabel = listsStore.getLists?.tutor.paid_label ?? {}

    return Object.entries(paidLabel).map(([key, text]) => ({
      id: key,
      value: key,
      text,
      selected: query.value.includes(key),
    }))
  })

  const initialValue = computed<string[]>(() => {
    return options.value
      .filter(option => option.selected)
      .map(option => option.text)
  })

  const handleSelected = (selected: MultiselectSearchOption[]): void => {
    query.value = selected.map(option => String(option.value))
  }

  return {
    options,
    query,
    initialValue,
    handleSelected,
  }
}
